export const hasCustomerManagementAccess = (
    isAssuming: boolean,
    allowCustomerManagementView?: boolean | number,
): boolean => isAssuming || !!allowCustomerManagementView;
